import React, { useEffect, useState } from 'react';
import '../styles/Projects.css';
import MainMenu from '../components/MainMenu';

function ProjectsPage() {
  const [openSections, setOpenSections] = useState({});

  // Load from localStorage on mount
  useEffect(() => {
    const saved = localStorage.getItem('openSections');
    if (saved) {
      setOpenSections(JSON.parse(saved));
    }
  }, []);

  // Save to localStorage whenever openSections changes
  useEffect(() => {
    localStorage.setItem('openSections', JSON.stringify(openSections));
  }, [openSections]);

  const toggleSection = (title) => {
    setOpenSections((prev) => ({
      ...prev,
      [title]: !prev[title],
    }));
  };

  const sections = [
    {
      title: 'composition',
      projects: 
      [
        { link: '/projects/terrain', label: 'terrain', year: "2022", image: '/images/terrain_1.webp' },
        { link: '/projects/---', label: '-  -  -', year: "2021", image: '/images/dashdashdash_2.webp' },
        { link: '/projects/neuroflux', label: 'neuro.flux', year: "2020", image: '/images/neuroflux_1.webp' },
        { link: '/projects/contain', label: '[CONTAIN]', year: "2019", image: '/images/sync.webp' },
        { link: '/projects/otbb', label: 'O.T.B.B', year: "2018", image: '/images/razor_old.webp' }
      ]
    },
    {
      title: 'installation',
      projects: 
      [
        // { link: '/projects/medus_iii', label: 'm e d u s a   I I I', year: "2 0 2 2", image: '/images/medusa_II.webp' },
        { link: '/projects/medusa_ii', label: 'medusa II', year: "2021", image: '/images/medusa_2.webp' },
        { link: '/projects/clubcrisis', label: 'club crisis', year: "2021", image: '/images/clubcrisis.webp'},
        { link: '/projects/medusa', label: 'medusa', year: "2018", image: '/images/medusa.webp' }
      ]
    },
    {
      title: 'music',
      projects: 
      [
        { link: '/projects/ZINK', label: 'ZINK', year: "2020----", image: '/images/assembly.webp' },
        { link: '/projects/creax', label: 'creax', year: "2015---2020", image: '/images/flowmechanics.webp' }, 
      ]
    },
    {
      title: 'software',
      projects:
      [
        {link: '/projects/ripple', label: 'ripple', year: '2021', image: '/images/ripple.webp'},
        {link: '/projects/orbit', label: 'orbit', year: '2020', image: '/images/orbit_2.webp'},
        {link: '/projects/bloom', label: 'bloom', year: '2018', image: '/images/bloom.webp'}
      ]
    },
    { 
      title: 'jewerly',
      projects: 
      [
        { link: '/projects/datadrip', label: 'DATA DRIP', year: '2025 ---', image: '/images/datadrip_6.webp'} 
      ]
    },
    {
      title: 'performance',
      projects: 
      [
        {link: '/projects/razor', label: 'R_A_Z_O_R', image: '/images/razor_oldold.webp', year: '2018'}
      ]
    },  
    {
      title: 'contributions',
      projects:
      [
        {link: 'https://www.quirijndees.com/symbionts', label: 'Quirijn Dees : Symbionts', image: 'images/symbionts.webp' , year: '2025', role: 'music'},
        {link: 'https://www.youtube.com/watch?v=U0mGqH8NVDM&t=946s', label: 'Sorza : Dumble', image: 'images/dumble.webp', year: '2024', role: 'visuals'},
        {link: 'https://www.quirijndees.com/pubertjimbob', label: 'Quirijn Dees : Pubert Jimbob', year: '2023', image: 'images/pubertjimbo.webp', role: 'music'},
        {link: 'https://www.youtube.com/watch?v=ypVL8twuBdA', label: 'TOOMBLAH : MIROBLOOM', image: 'images/toomblah.webp', year: '2022', role: 'visuals'},
        {link: 'https://v2.nl/works/fragments#', label: 'Leo Scarin : fragments', image: 'images/fragments.webp', year: '2021', role: 'sound-design'}
      ]
    },
    {
      title: 'professional',
      projects: 
      [
        {link: "https://studiodrift.com/", label: 'Studio DRIFT', image: '/images/drift 2.webp', year: '2022-current', role: 'creative technical lead'},
        {link: 'https://www.showsync.com/', label: 'Showsync', image: 'images/showsync.webp', year: '2020-current', role: 'visual developer'}
      ]
    }
  ];

  
  const isExternalLink = (url) => /^https?:\/\//.test(url);

  return (
    <div className="projects-page">
      <MainMenu />
      <div className="projects-container">
        {sections.map((section, index) => (
          <div className="project-section" key={index}>
            <h2
              className="section-title"
              onClick={() => toggleSection(section.title)}
            >
              {section.title}
              <span className="section-toggle">
                {openSections[section.title] ? '–' : '+'}
              </span>
            </h2>
            {openSections[section.title] && (
              <div className="projects-grid">
                {section.projects.map((project, i) => {
                  const external = isExternalLink(project.link);
                  return (
                    <a
                      key={i}
                      href={project.link}
                      className="project-card"
                      target={external ? '_blank' : undefined}
                      rel={external ? 'noopener noreferrer' : undefined}
                    >
                      <div className="project-card-title">{project.label}</div>
                      <div className="project-card-role">{project.role}</div>
                      <img
                        src={project.image}
                        alt={project.label}
                        className="project-card-image"
                      />
                      <div className="project-card-year">{project.year}</div>
                    </a>
                  );
                })}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
  
}

export default ProjectsPage;
